export const ADD_TASK_HISTORY = 'ADD_TASK_HISTORY';
export const LOAD_TASK_HISTORY_BY_ID = 'LOAD_TASK_HISTORY_BY_ID';
export const LOAD_TASK_HISTORY_POSITION_BY_ID = 'LOAD_TASK_HISTORY_POSITION_BY_ID';
export const LOAD_TASK_HISTORY_STATUS_BY_ID = 'LOAD_TASK_HISTORY_STATUS_BY_ID';
export const LOAD_TASK_HISTORY_CREATED_BY_ID = 'LOAD_TASK_HISTORY_CREATED_BY_ID';
export const LOAD_TASK_HISTORY_UPDATED_BY_ID = 'LOAD_TASK_HISTORY_UPDATED_BY_ID';
export const LOAD_TASK_HISTORY_VIEW_BY_ID = 'LOAD_TASK_HISTORY_VIEW_BY_ID';
export const ADD_TASK_HISTORY_STATUS = 'ADD_TASK_HISTORY_STATUS';
export const ADD_TASK_HISTORY_WITH_STATUS_CREATED = 'ADD_TASK_HISTORY_WITH_STATUS_CREATED';
export const ADD_TASK_HISTORY_WITH_STATUS_UPDATED = 'ADD_TASK_HISTORY_WITH_STATUS_UPDATED';
export const ADD_TASK_HISTORY_WITH_STATUS_VIEW = 'ADD_TASK_HISTORY_WITH_STATUS_VIEW';


export function addTaskHistory(data) {
  return {
    type: ADD_TASK_HISTORY,
    payload: data,
  }
}

export function loadTaskHistoryById(data) {
    return {
      type: LOAD_TASK_HISTORY_BY_ID,
      payload: data,
    }
}

export function loadTaskHistoryPositionById(data) {
    return {
      type: LOAD_TASK_HISTORY_POSITION_BY_ID,
      payload: data,
    }
}

export function loadTaskHistoryStatusById(data) {
    return {
      type: LOAD_TASK_HISTORY_STATUS_BY_ID,
      payload: data,
    }
}

export function loadTaskHistoryCreatedById(data) {
    return {
      type: LOAD_TASK_HISTORY_CREATED_BY_ID,
      payload: data,
    }
}

export function loadTaskHistoryUpdatedById(data) {
    return {
      type: LOAD_TASK_HISTORY_UPDATED_BY_ID,
      payload: data,
    }
}

export function loadTaskHistoryViewById(data) {
    return {
      type: LOAD_TASK_HISTORY_VIEW_BY_ID,
      payload: data,
    }
}

export function addTaskHistoryStatus(data) {
    return {
      type: ADD_TASK_HISTORY_STATUS,
      payload: data,
    }
}

export function addTaskHistoryWithStatusCreated(data) {
    return {
      type: ADD_TASK_HISTORY_WITH_STATUS_CREATED,
      payload: data,
    }
}

export function addTaskHistoryWithStatusUpdated(data) {
    return {
      type: ADD_TASK_HISTORY_WITH_STATUS_UPDATED,
      payload: data,
    }
}

export function addTaskHistoryWithStatusView(data) {
    return {
      type: ADD_TASK_HISTORY_WITH_STATUS_VIEW,
      payload: data,
    }
}


// WEBPACK FOOTER //
// ./src/actions/taskHistory/index.js